import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=22316a5a&scoped=true&"
import script from "./Wysiwyg.vue?vue&type=script&lang=js&"
export * from "./Wysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./Wysiwyg.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Wysiwyg.vue?vue&type=style&index=1&id=22316a5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22316a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22316a5a')) {
      api.createRecord('22316a5a', component.options)
    } else {
      api.reload('22316a5a', component.options)
    }
    module.hot.accept("./Wysiwyg.vue?vue&type=template&id=22316a5a&scoped=true&", function () {
      api.rerender('22316a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/Wysiwyg.vue"
export default component.exports